import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Pagination = props => {
  const { className, theme, size, tag: Tag, ...attributes } = props

  const classes = classNames(className, theme['pagination'], {
    [theme[`pagination-${size}`]]: !!size,
  })

  return <Tag {...attributes} className={classes} />
}

Pagination.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  theme: PropTypes.object.isRequired,
  size: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
}

Pagination.defaultProps = {
  tag: 'ul',
}

export default Pagination



// WEBPACK FOOTER //
// ./ui/Pagination/Pagination.js